module.exports = __webpack_public_path__ + "assets/macarun.info.7f63e3b8dbee1d44061f7dd8e1b136f5c566ba1edf075768aa2c58e55b5ba924.png";